import React, { useEffect } from "react"

import { useNavigate, useSearchParams } from "react-router-dom"

import { PageHelmetElement } from "@front-shared/elements/pageHelmet.element"
import { SpinnerElement } from "@front-shared/elements/spinner.element"
import { ToastrHelper } from "@front-shared/helpers/toastr.helper"

import { GENERAL_CONFIG } from "../../config/general.config"
import { ROUTES_CONFIG } from "../../config/routes.config"
import { UtilHelper } from "../../helpers/util.helper"
import { useAppDispatch } from "../../store/appDispatch.hook"
import { authConfirmUser } from "../../store/thunks/auth.thunks"

export const ConfirmUserComponent: React.FunctionComponent = () => {
    const dispatch = useAppDispatch()

    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const email = UtilHelper.getRawUrlSearchParam(
            GENERAL_CONFIG.urlSearchParamsKeys.email,
        )

        const confirmationCode = searchParams.get(
            GENERAL_CONFIG.urlSearchParamsKeys.verificationCode,
        )

        if (!email || !confirmationCode) {
            ToastrHelper.error("Bad data provided, please try again")

            navigate(ROUTES_CONFIG.loginUrl)

            return
        }

        dispatch(
            authConfirmUser({
                payload: {
                    email,
                    confirmationCode,
                },
                navigate,
            }),
        )
    }, [])

    return (
        <div>
            <PageHelmetElement
                title="Confirm Account"
                defaultPageTitle={GENERAL_CONFIG.defaultPageTitle}
            />

            <SpinnerElement containerClassName="text-center mt-[20px]" />
        </div>
    )
}
